import { render, staticRenderFns } from "./LeaveTypeDetail.vue?vue&type=template&id=4d080917"
import script from "../../controllers/leave_type/leave-type-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/leave_type/leave-type-detail.js?vue&type=script&lang=js&external"
import style0 from "./LeaveTypeDetail.vue?vue&type=style&index=0&id=4d080917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports